import { LoadingAction } from "./action";
import { isLoadingState, isLoading } from "./state";

export function isLoadingReducer (state:isLoadingState=isLoading,action:LoadingAction):isLoadingState{
    switch(action.type){
        case "@@loading/isLoadingAction":
            return {
                ...state,
                isLoading:action.isLoading
            }
        default:
            return state
    }
}

